import { Grid, SxProps, Theme, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import Libelle from "../../_i18n/fr.json";
import Bouton from "../../components/Button/Bouton";
import Layout from "../../components/Layout";
import theme from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.pageIntrouvable": {
      textAlign: "center",
      "& h1": {
        letterSpacing: 2,
        fontSize: 42,
        padding: "24px",
        fontWeight: "bold",
        color: theme.palette.primary.main,
      },
      "& h2": {
        paddingBottom: "12px",
      },
    },
    "& .caption": {
      marginTop: "24px",
      margin: "12px",
    },
  },
];

function PageIntrouvable() {
  const navigate = useNavigate();
  const onBackHome = () => {
    navigate("/");
  };
  return (
    <React.Fragment>
      <Layout title={Libelle.pageIntrouvable.titre}>
        <Grid
          sx={styles}
          className={"pageIntrouvable"}
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Typography variant="h1">OUPS !</Typography>
          <Typography variant="h2">{Libelle.pageIntrouvable.h1}</Typography>
          <Grid item>{Libelle.pageIntrouvable.libelle}</Grid>
          <Typography variant="caption" className={"caption"}>
            Vous pouvez vérifier votre URL ou retourner à la page d'accueil
          </Typography>
          <Bouton
            onClick={onBackHome}
            label="Retour à la page d'accueil"
            color="primary"
          />
          <br />
          <br />
        </Grid>
      </Layout>
    </React.Fragment>
  );
}

export default PageIntrouvable;
